"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _ErrorOutline = _interopRequireDefault(require("@material-ui/icons/ErrorOutline"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function SttAlertButton() {
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "primary",
    disableRipple: true,
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(_ErrorOutline["default"], null));
}
var _default = SttAlertButton;
exports["default"] = _default;